import { render, staticRenderFns } from "./AppointmentRoute.vue?vue&type=template&id=b8c1c676"
import script from "./AppointmentRoute.vue?vue&type=script&lang=js"
export * from "./AppointmentRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports